<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
        <h1>Bestätigung Ihrer Meldung</h1>
      </v-col>
        <v-col cols="12">
          Danke, dass Sie uns über den Vorfall informiert haben.
      </v-col>
      <v-col class="text-center" cols="12">
        <v-btn-group>
          <v-btn  @click="$router.push('/')" color="primary">Sie können die Seite jetzt schließen.</v-btn>
        </v-btn-group>
      </v-col>
      </v-row>

  </v-container>
</template>

<script>

import {mapActions} from "vuex";

export default {
  name: 'ReportView',
  data: () => ({
  }),
  methods: {
    ...mapActions(['report'])
  },
  mounted() {
    const id = this.$route.query.id
    if (id) {
      this.report((id))
    }
  }
}
</script>

<style scoped>
p {
  padding-left:10px;
  padding-bottom: 10px;
}
</style>